import axios from 'axios';
import { getAuthHeader } from './userInfo-actions';
import { searchDataActions } from './search-slice';

export const searchData = (
  searchText,
  ownerName,
  privado,
  idAcademy
) => {
  return async dispatch => {
    let searchData = await axios.get(
      `${process.env.REACT_APP_API_PATH_COURSE_ADDITIONAL}/search`,
      {
        params: {
          elements: 3,
          f: searchText,
          privado,
          ownerName,
          extraOrgs: idAcademy
        },
        headers: getAuthHeader()
      }
    );

    if (searchData.status === 200) {
      dispatch(
        searchDataActions.info({
          searchInfo: searchData.data
        })
      );
    }
  };
};
